import { render } from "./SalesStatList.vue?vue&type=template&id=62282e1c&scoped=true"
import script from "./SalesStatList.vue?vue&type=script&lang=js"
export * from "./SalesStatList.vue?vue&type=script&lang=js"

import "./SalesStatList.vue?vue&type=style&index=0&id=62282e1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62282e1c"]])

export default __exports__